/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedWordpressArticles_itemSearch = {
    readonly editorialArticles: {
        readonly totalResults: number | null;
        readonly " $fragmentRefs": FragmentRefs<"EditorialModule_editorialArticles">;
    } | null;
    readonly " $refType": "SharedWordpressArticles_itemSearch";
};
export type SharedWordpressArticles_itemSearch$data = SharedWordpressArticles_itemSearch;
export type SharedWordpressArticles_itemSearch$key = {
    readonly " $data"?: SharedWordpressArticles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedWordpressArticles_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedWordpressArticles_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "WordpressArticlesType",
      "kind": "LinkedField",
      "name": "editorialArticles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorialModule_editorialArticles"
        }
      ],
      "storageKey": "editorialArticles(first:2)"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '5af42599a352fe6080a3747c61e65797';
export default node;
